import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Compass, Home } from 'lucide-react';
import { Link } from '@tanstack/react-router';

/**
 * Rendered by the router's defaultNotFoundComponent for any unmatched route.
 * Under /dashboard the router resolves the not-found at the dashboard route,
 * so this lands in the shell's outlet with the sidebar still around it.
 */
export function NotFound() {
  return (
    <div data-testid="not-found" className="flex items-center justify-center min-h-[60vh] p-6">
      <Card className="max-w-md w-full text-center">
        <CardHeader>
          <div className="flex justify-center mb-4">
            <div className="rounded-full bg-slate-100 dark:bg-slate-800 p-4">
              <Compass className="h-12 w-12 text-slate-500 dark:text-slate-300" />
            </div>
          </div>
          <CardTitle className="text-2xl">
            <h1>Page Not Found</h1>
          </CardTitle>
          <CardDescription className="text-base mt-2">
            That page doesn&apos;t exist. Check the address, or head back to the dashboard.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <Link to="/dashboard">
            <Button variant="default" className="w-full">
              <Home className="h-4 w-4 mr-2" />
              Back to Dashboard
            </Button>
          </Link>
        </CardContent>
      </Card>
    </div>
  );
}
